export enum CronJobType {
    Minute,
    EveryFewMinutes,
    Hourly,
    Daily,
    Weekly,
    Monthly,
}
